import { trustPoints, testimonials } from '@/mocks/seoContent';

export default function TrustSection() {
  return (
    <section className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-md mb-4">
            Trust &amp; Reliability
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight">
            Why This System
            <br />
            is Reliable
          </h2>
          <p className="mt-4 text-sm text-foreground-600 max-w-xl leading-relaxed">
            The OOPBuy Spreadsheet system follows structured data principles that prioritize transparency, user control, and consistent information organization — key factors that contribute to its trustworthiness as a sourcing tool.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-16">
          {trustPoints.map((point) => (
            <div
              key={point.title}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/60"
            >
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-4">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-700 text-lg"></i>
                </span>
              </div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-2">
                {point.title}
              </h4>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mb-8">
          <h3 className="text-sm font-semibold text-foreground-950">
            What Users Say
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.slice(0, 6).map((t) => (
            <div
              key={t.handle}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-secondary-700">
                    {t.avatar}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-500">
                    {t.handle}
                  </p>
                </div>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">
                &ldquo;{t.quote}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}